import { z } from 'zod'

export const productPrivilegeValidation = z
  .object({
    productId: z.string().min(1, { message: 'Must select a product' }),
    list: z.array(z.object({
      code: z.string().min(1, { message: 'Must select a code' }),
      name: z.string().min(1, { message: 'Must select a title' }),
    })),
  })

export type ProductPrivilegeValidation = z.infer<typeof productPrivilegeValidation>
